import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
// Lazy load everything below the fold
const GalleryMarquee = lazy(() => import('./components/GalleryMarquee').then(m => ({
  default: m.GalleryMarquee
})));
const LetterSection = lazy(() => import('./components/LetterSection').then(m => ({
  default: m.LetterSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TestimonialSection = lazy(() => import('./components/TestimonialSection').then(m => ({
  default: m.TestimonialSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const FeaturesSection = lazy(() => import('./components/FeaturesSection').then(m => ({
  default: m.FeaturesSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterCTA = lazy(() => import('./components/FooterCTA').then(m => ({
  default: m.FooterCTA
})));
const StickyMobileCTA = lazy(() => import('./components/StickyMobileCTA').then(m => ({
  default: m.StickyMobileCTA
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  useEffect(() => {
    document.title = '100ads app';
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute('href', 'https://cdn.magicpatterns.com/uploads/oTx46CWhekMbGtneQivY5E/Gemini_Generated_Image_4pf4504pf4504pf4.jpg');
    } else {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/jpeg';
      favicon.href = 'https://cdn.magicpatterns.com/uploads/oTx46CWhekMbGtneQivY5E/Gemini_Generated_Image_4pf4504pf4504pf4.jpg';
      document.head.appendChild(favicon);
    }
    const metaTags: Record<string, string> = {
      description: 'Generá +100 creativos estáticos que venden en solo 10 minutos. 100ads es el sistema de volumen extremo para Meta Ads de productos digitales.',
      keywords: 'creativos meta ads, generador de creativos, ads para infoproductos, testing de creativos, ángulos de venta, media buying, ROAS, publicidad digital, 100ads',
      author: '100ads',
      robots: 'index, follow',
      'theme-color': '#8B5CF6',
      'og:title': '100ads app',
      'og:description': 'El sistema de volumen extremo para generar creativos estáticos listos para Meta Ads. Acceso mensual, cancelá cuando quieras.',
      'og:image': 'https://cdn.magicpatterns.com/uploads/pebU2U1j6vhP1yWsMDmY62/Gemini_Generated_Image_phn3a8phn3a8phn3.jpg',
      'og:type': 'website',
      'twitter:card': 'summary_large_image',
      'twitter:title': '100ads app',
      'twitter:description': 'Generá +100 creativos estáticos que venden en solo 10 minutos. Sistema de volumen extremo para Meta Ads.',
      'twitter:image': 'https://cdn.magicpatterns.com/uploads/pebU2U1j6vhP1yWsMDmY62/Gemini_Generated_Image_phn3a8phn3a8phn3.jpg'
    };
    Object.entries(metaTags).forEach(([key, value]) => {
      const isOg = key.startsWith('og:');
      const isTwitter = key.startsWith('twitter:');
      const attr = isOg || isTwitter ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, key);
        document.head.appendChild(meta);
      }
      meta.content = value;
    });
  }, []);
  return <main className="min-h-screen bg-[#020202] text-white selection:bg-purple-500/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <TrustBar data-id="element-3" />
      <Suspense fallback={null} data-id="element-4">
        <GalleryMarquee data-id="element-5" />
        <LetterSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <TestimonialSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <MechanismSection data-id="element-10" />
        <FeaturesSection data-id="element-11" />
        <BonusSection data-id="element-12" />
        <PricingSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FooterCTA data-id="element-16" />
        <StickyMobileCTA data-id="element-17" />
        <MetaPixel data-id="element-18" />
      </Suspense>
    </main>;
}